import { useState } from "react";
import { AppContext, defaultAppState } from "./AppContext";

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = useState(defaultAppState);

  return <AppContext.Provider value={{ state, setState }}>{children}</AppContext.Provider>;
};
